<template>
  <v-container v-if="customer" fluid class="pa-0" style="height: inherit">
    <v-row no-gutters style="height: inherit">
      <v-col :cols="isPcBool ? 7 : 12" class="px-4" :style="isPcBool ? 'background-color: #fefefe;' : ''">

        <!--
        <v-row no-gutters style="position: relative;">
          <PlannedConstruction overlayed section />
          <v-row no-gutters
                 class="mt-4">
            <v-col>
              <v-card class="pa-12 d-flex justify-center">
                <v-icon size="200">mdi-chart-areaspline-variant</v-icon>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="d-flex flex-column justify-space-between">
              <v-card v-for="index in 3"
                      :key="index"
                      height="29%"
                      color="primary"
                      class="white--text px-3 py-1">
                <div>kpi number {{index}}</div>
                <h2 class="font-weight-regular">12313123</h2>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-12 d-flex justify-center">
                <v-icon size="140">mdi-chart-gantt</v-icon>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-12 d-flex justify-center">
                <v-icon size="140">mdi-chart-sankey</v-icon>
              </v-card>
            </v-col>
          </v-row>
        </v-row>
        -->

        <v-row no-gutters>
          <v-col :cols="12">
            <SectionHeader :title="$t('servicesystem.common_objects.commonterms.details')" />
            <v-card v-if="editObject" v-click-outside="unfocusEntireCard">
              <slotted-card :editable="true"
                :title="editObject && editObject.Name ? editObject.Name : $t('servicesystem.common_objects.fallbackterms.no_customer_name')"
                :icon="'$customer'" :fontsize="'h3'" :externalEditTrigger="edittrigger" @editMode="setEditMode"
                @valid="setValid">
                <template v-slot:headertitle>
                  <QTextField v-model="editObject.Name"
                    :label="$t('servicesystem.common_objects.customer.customer_name')" :externaledit="editMode"
                    singleline @FocusState="editMode ? null : edittrigger++" class="h3">
                  </QTextField>
                </template>
                <template v-slot:content>
                  <v-container fluid class="py-0">
                    <v-row no-gutters>
                      <v-col cols="8" class="pr-3 pt-3">
                        <v-row no-gutters>
                          <v-col>
                            <QTextField v-model="editObject.Id"
                              :label="$t('servicesystem.common_objects.customer.customer_number')" disabled>
                            </QTextField>
                          </v-col>
                          <v-col>
                            <QTextField v-model="editObject.OrganisationNumber"
                              :label="$t('servicesystem.common_objects.customer.organization_number')"
                              :externaledit="editMode" @FocusState="editMode ? null : edittrigger++">
                            </QTextField>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <EditLi :label="$t('servicesystem.common_objects.customer.credit_limit')" class="ml-n5"
                              :value="editObject.CreditLimit ? editObject.CreditLimit : $t('servicesystem.common_objects.commonterms.none')"
                              :suffix="editObject.CreditLimitExceeded ? (' (' + editObject.CreditLimitExceeded + ')') : null"
                              :valuecolor="editObject.CreditLimit ? (editObject.CreditLimitExceeded ? 'error' : 'primary') : 'disabled'" />
                          </v-col>
                          <v-col>
                            <QSwitchInput v-model="editObject.FreeFromVat"
                              :label="$t('servicesystem.common_objects.customer.free_from_vat')"
                              :externaledit="editMode" @FocusState="editMode ? null : edittrigger++">
                            </QSwitchInput>
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="mx-n3 mt-3 px-3 pt-1" :class="editMode ? 'pb-2' : 'rounded-b'"
                          style="background-color: rgb(255 249 242);">
                          <v-col>
                            <QTextArea v-model="editObject.Comments" :backgroundcolor="'rgb(255 249 242)'"
                              :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampCustomerNote"
                              :singleline="!editObject.Comments"
                              :placeholder="!editObject.Comments ? $t('servicesystem.common_objects.customer.note') : undefined"
                              :label="$t('servicesystem.common_objects.customer.note')" :externaledit="editMode"
                              @FocusState="editMode ? null : edittrigger++">
                            </QTextArea>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-divider vertical />
                      <v-col cols="4" class="pl-3 pt-3">
                        <DepartmentSelect v-model="editObject.DepartmentId" clearable hideIcon :externaledit="editMode"
                          @FocusState="editMode ? null : edittrigger++">
                        </DepartmentSelect>
                        <QTextField v-model="editObject.Longitude"
                          :label="$t('servicesystem.common_objects.customer.longitude')" :externaledit="editMode"
                          @FocusState="editMode ? null : edittrigger++">
                        </QTextField>
                        <QTextField v-model="editObject.Latitude"
                          :label="$t('servicesystem.common_objects.customer.latitude')" :externaledit="editMode"
                          @FocusState="editMode ? null : edittrigger++">
                        </QTextField>
                      </v-col>
                    </v-row>
                   
                  </v-container>
                  <edit-bar v-if="editMode" :externalTrigger="editMode" :saveable="valid && IsChanged"
                    @saveEmit="handleSave" @modeEmit="edittrigger++">
                  </edit-bar>
                </template>
              </slotted-card>
            </v-card>
          </v-col>
          <v-col cols="12" v-if="customer.CustomerGroupNo || customer.ParentId">
            <SectionHeader :title="$t('servicesystem.common_objects.commonterms.belongs_to')" />
            <v-card class="py-2" v-if="customer.CustomerGroupNo || customer.ParentId">
              <v-row no-gutters>
                <v-col v-if="customer.CustomerGroupNo">
                  <CustomerGroupCard :id="customer.CustomerGroupNo" />
                </v-col>
                <v-col v-if="customer.ParentId">
                  <ParentCustomerCard :id="customer.ParentId" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="customer && customer.Id !== undefined" :cols="isPcBool ? 5 : 12" class="px-4 pb-4"
        style="background-color: rgb(248, 248, 248) !important;">
        <v-row no-gutters>
          <v-col :cols="isPcBool ? 12 : null" :class="!isPcBool && !isPhoneBool ? 'mr-2' : ''">
            <SectionHeader :title="$t('servicesystem.common_objects.address.addresses')" />
            <v-card>
              <CustomerAddresses :Customer="customer" />
            </v-card>
          </v-col>
          <v-col :cols="isPcBool ? 12 : null" :class="!isPcBool && !isPhoneBool ? 'ml-2' : ''">
            <SectionHeader :title="$t('servicesystem.common_objects.contact.contacts')" />
            <v-card>
              <CustomerContacts :Customer="customer" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import EditLi from "@/components/Inputs/EditableListItem.vue";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import CustomerAddresses from "@/views/customer/customers/CustomerAddresses.vue";
import CustomerContacts from "@/views/customer/customers/CustomerContacts.vue";
import CustomerGroupCard from "@/views/job/newjob/cards/customer/CustomerGroupCard.vue";
import ParentCustomerCard from "@/views/job/newjob/cards/customer/ParentCustomerCard.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";
//import PlannedConstruction from "@/views/landingpages/PlannedConstruction.vue";

export default {
  name: "CustomerDetails",
  props: {
    containerItem: Object,
  },
  components: {
    SlottedCard,
    EditBar,
    SectionHeader,
    CustomerGroupCard,
    ParentCustomerCard,
    CustomerAddresses,
    CustomerContacts,
    EditLi,
    DepartmentSelect,
    //PlannedConstruction
  },
  mixins: [clientAPI],

  data() {
    return {
      editObject: null,
      copyObject: null,
      edittrigger: 0,
      editMode: false,
      valid: false,
    };
  },

  mounted() {
    this.SetDetails();
  },

  methods: {
    setEditMode(bool) {
      this.editMode = bool;
    },

    setValid(bool) {
      this.valid = bool;
    },

    SetDetails() {
      var defaultobj = {
        Id: null,
        ParentId: null,
        CustomerGroupNo: "",
        Name: "",
        OrganisationNumber: "",
        CreditLimit: null,
        CreditLimitExceeded: null,
        FreeFromVat: false,
        Latitude: "",
        Longitude: "",
        IsActive: true,
        AllowPublicView: null,
        DefaultCustomerPerson: {},
        DefaultDeliveryAddress: {},
        AddedFields: {},
      };

      var existingcopy = Object.assign({}, this.customer);
      var obj = this.customer ? existingcopy : defaultobj;

      this.editObject = Object.assign({}, obj);
      this.copyObject = Object.assign({}, obj);
      this.copyObject.AddedFields = Object.assign({}, this.editObject.AddedFields);
    },

    handleSave() {
      const dto = Object.assign({}, this.editObject);
      //console.log("Sending change", dto);
      this.changeCustomerById(dto)
        .then((response) => {
          //console.log("Recieved", Object.assign({}, response));
          this.$emit('SetContainerItem', response);
          this.edittrigger++;
        })
        .catch((exception) => {
          console.error(exception);
          this.customer = null;
        });
    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.edittrigger++;
      }
    },
  },

  computed: {
    customer() {
      return this.containerItem;
    },

    IsChanged() {
      if (this.editObject && this.copyObject) {
        return !this.SameValue(this.editObject, this.copyObject);
      } else {
        return false;
      }
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },
  },

  watch: {
    customer: function () {
      this.SetDetails();
    },

    editMode: function (newVal) {
      if (!newVal) {
        this.SetDetails();
      }
    },
  },
};
</script>


<style lang='scss'>
.q-input.h3 textarea {
  color: #5f5f5f !important;
}
</style>